module.exports = __webpack_public_path__ + "static/media/brian-lara-era.4df42615.png";